<template>
    <v-layout column justify-center align-center py-4>
      <v-card class="reset-wrap pa-4 mb-5">
        <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">{{err}}
        </v-alert>
        <v-alert
          color="success"
          class="success"
          icon="warning"
          value="true"
          v-if="success">{{success}}
        </v-alert>
        <v-layout column justify-start>
          <v-flex class="sub-header">
            <p class="inline">{{$lang.global.selectMethod}}:</p>
          </v-flex>
          <v-flex class="radio-wrap">
            <v-radio-group v-model="method" class="pt-0">
              <v-layout row wrap justify-start align-center class="radio-wrap pt-0">
                <v-flex>
                  <v-radio
                    type="radio"
                    :label="$lang.global.byEmail"
                    value="email"
                    class="single-radio mb-2"/>
                </v-flex>
                <v-flex>
                  <v-radio
                    type="radio"
                    :label="$lang.global.byPhone"
                    value="phone"
                    class="single-radio"/>
                </v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-form v-model="valid" @submit.native.prevent="submit()" ref="form">
          <v-text-field
            :label="$lang.labels.email"
            v-model="email"
            name="email"
            :rules="emailRules"
            required
            v-show="method === 'email'"
          ></v-text-field>
          <v-text-field
                  :label="$lang.labels.phone"
            v-model="phone"
            name="phone"
            :rules="[phoneNumberRules]"
            required
            v-show="method === 'phone'"
          ></v-text-field>
          <v-flex xs12 class="text-xs-right">
            <v-btn
              color="primary"
              type="submit"
              :disabled="!isValid"
              class="ma-0">{{$lang.actions.send}}</v-btn>
          </v-flex>
        </v-form>
      </v-card>
    </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        method: 'email',
        valid: false,
        email: this.$route.query.email || '',
        phone: this.$route.query.phone || '',
        emailField: undefined,
        phoneField: undefined,
        emailRules: [
          // eslint-disable-next-line
          v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
        ],
        err: '',
        success: '',
      };
    },
    computed: {
      ...mapGetters({
        company: 'company',
      }),
      phoneNumberRules() {
        if (this.company && (this.phone || this.phone !== '')) {
          return this.testPhoneNumberRules(this.company.address.country, this.phone);
        }
        return this.$lang.errors.requiredPhone;
      },
      isValid() {
        return !this[`${this.method}Field`] ? false : this[`${this.method}Field`].valid;
      },
    },
    methods: {
      testPhoneNumberRules(country, phone) {
        if (!phone) return this.$lang.errors.requiredPhone;
        if (!country) return this.$lang.errors.countryRequired;
        if (country === 'UK') {
          return ([10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) &&
                  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone)) || this.$lang.errors.notValidPhone;
        }
        if (country === 'AT') {
          let tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
          if (tempPhone.substring(0, 2) === '00') {
            tempPhone = tempPhone.substring(2, tempPhone.length);
          }
          if (tempPhone.substring(0, 2) === '43') {
            tempPhone = `0${tempPhone.substring(2, tempPhone.length)}`;
          }
          let checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
          if (!checkPhone) {
            checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
          }
          return checkPhone || this.$lang.errors.notValidPhone;
        }
        return this.$lang.errors.countryUnsupported;
      },
      submit() {
        if (!this.isValid) return;
        if (!this.email && !this.phone) {
          this.err = this.$lang.errors.phoneOrEmail;
          return;
        }
        this.err = '';
        const data = {};
        if (this.method === 'email' && this.email) {
          Object.assign(data, { email: this.email });
        }
        if (this.method === 'phone' && this.phone) {
          Object.assign(data, { phone: this.phone });
        }
        this.$webHelper.post('user/sendemailforresetpassword', data, this.$router)
          .then((res) => {
            if (!res.success) {
              // eslint-disable-next-line max-len
              this.err = res.body && res.body.statusText ? res.body.statusText : this.$lang.errors.failToSend;
              return;
            }
            this.success = this.$lang.success.sendSuccess;
            setTimeout(() => {
              this.success = '';
            }, 5000);
          });
      },
    },
    mounted() {
      this.emailField = this.$refs.form.inputs.find(input => input.label === 'Email');
      this.phoneField = this.$refs.form.inputs.find(input => input.label === 'Phone');
    },
  };
</script>

<style lang="scss" scoped>
  .reset-wrap {
    min-width: 300px;
    width: 100%;
    max-width: 380px;
  }
  .radio-wrap .single-radio {
    padding-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Password-forgot.vue